import React, { useCallback, useEffect, useState } from "react";
import { EmblaCarouselType } from "embla-carousel";
import { IconButton, IconButtonProps } from "@mui/material";
import { ArrowSplideLeft, ArrowSplideRight } from "../../../icons";

type UsePrevFeaturedNextButtonsType = {
  prevBtnDisabled: boolean;
  nextBtnDisabled: boolean;
  onPrevButtonClick: () => void;
  onNextButtonClick: () => void;
};

export const usePrevFeaturedNextButtons = (
  emblaApi: EmblaCarouselType | undefined
): UsePrevFeaturedNextButtonsType => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on("reInit", onSelect).on("select", onSelect);
  }, [emblaApi, onSelect]);

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  };
};
type PropType = IconButtonProps;

export const PrevFeaturedButton: React.FC<PropType> = (props) => {
  const { children, ...restProps } = props;

  return (
    <IconButton
      className="embla__button__featured embla__button--prev"
      type="button"
      {...restProps}
    >
      <ArrowSplideLeft
        sx={{
          width: { xs: "18px !important", md: "24px !important" },
          height: { xs: "18px !important", md: "24px !important" },
        }}
        htmlColor="#0000008f"
      />
    </IconButton>
  );
};

export const NextFeaturedButton: React.FC<PropType> = (props) => {
  const { children, ...restProps } = props;

  return (
    <IconButton
      className="embla__button__featured embla__button--next"
      type="button"
      {...restProps}
    >
      <ArrowSplideRight
        sx={{
          width: { xs: "18px !important", md: "24px !important" },
          height: { xs: "18px !important", md: "24px !important" },
        }}
        htmlColor=" #0000008f "
      />
    </IconButton>
  );
};
